import * as React from "react";
import { Combobox } from "./combobox";
import { timezoneChoices } from "../lib/timezones";

interface TimezoneComboboxProps {
  /** The stored IANA name. Kept in the list even when the runtime does not know it. */
  value: string;
  onChange: (zone: string) => void;
  placeholder?: string;
  searchPlaceholder?: string;
  emptyLabel?: string;
  disabled?: boolean;
  /** An empty value is a real answer (e.g. "follow the site's zone"): a clear (x) control. */
  clearable?: boolean;
  clearLabel?: string;
  className?: string;
  popoverClassName?: string;
  /** See `Combobox`: `true` inside a modal Dialog. */
  modal?: boolean;
  /** The trigger's id, so a visible `<label htmlFor>` names it. */
  id?: string;
  "aria-label"?: string;
}

/**
 * A searchable pick of every IANA time zone, each shown with its UTC offset, so an
 * operator types "tallinn" or "utc+3" instead of spelling `Europe/Tallinn` by hand.
 *
 * The offsets are read once per value: they only move on a daylight saving change, and a
 * label that is an hour stale until the next pick is harmless.
 */
export function TimezoneCombobox({ value, ...rest }: TimezoneComboboxProps) {
  const options = React.useMemo(() => timezoneChoices(value), [value]);
  return <Combobox options={options} value={value} {...rest} />;
}
